import { AppSyncFarm, MonitorVaults } from 'common/models/farm';
import React from 'react';
import { FarmUtils } from 'utils/farmUtils';
import qs from 'qs';
import { LinkButton } from '../LinkButton/LinkButton';
import SwitchNetworkContainer from 'containers/SwitchNetworkContainer';
import useSelectedChain from 'hooks/useSelectedChain';

type Props = {
    farm: AppSyncFarm;
    vault: MonitorVaults | undefined;
  };
  
const VaultActionButton: React.FC<Props> = (props) => {
    const { chainId } = useSelectedChain();
    const farm = props.farm;
    const baseToken = FarmUtils.getBaseToken(farm);
    const rewardToken = FarmUtils.getRewardToken(farm);
  
    const isPancakeVault = FarmUtils.isPancakeVault(farm, props.vault ? [props.vault] : []);

    const depositLink = !isPancakeVault 
        ? `/vault?${qs.stringify({
            token: baseToken.address,
            pairedtoken: rewardToken.address,})}`
        : 'https://pancakeswap.finance/position-managers';

    const btnLabel = !isPancakeVault 
        ? 'Deposit'
        : 'Deposit on PancakeSwap';

    const linkTarget = !isPancakeVault 
        ? 'self'
        : 'blank';


    return (<>
        {farm.chainId !== chainId && !isPancakeVault ? (
            <SwitchNetworkContainer
                btnClassName="loadable-default button primary-button-bg-color primary-button-color page-btn px-2"
                newChainId={farm.chainId}
            />
        ) : (
            <LinkButton
                to={depositLink}
                id={farm.poolId.toString()}
                className="w-40"
                heightClass="page-btn"
                target={linkTarget}
            >
                {btnLabel}
            </LinkButton>
        )}
    </>);
};

export default VaultActionButton;
